export default __webpack_public_path__ + "static/media/CrudeFigure2.bc89494b.jpeg";